import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'gatsby'
import { css } from '@emotion/react'
import { string, object } from 'prop-types'

import { getAppLink } from '@/store/selectors'
import { LocalImage } from '@/components/LocalImage'

const wrapperCss = css`
  height: 40px;
  display: block;

  > img {
    height: 100%;
    object-fit: contain;
  }
`

const AppLogo = ({ campaign, name, link }) => {
  if (link) {
    return (
      <Link css={wrapperCss} to={link} suppressHydrationWarning>
        <LocalImage
          image={campaign.logo}
          fallbackUrl={campaign.properties?.logo}
          alt={name}
        />
      </Link>
    )
  }

  return (
    <div css={wrapperCss}>
      <LocalImage
        image={campaign.logo}
        fallbackUrl={campaign.properties?.logo}
        alt={name}
      />
    </div>
  )
}

const mapStateToProps = (state, { campaign, name }) => {
  const app = campaign?.applications ? campaign.applications[0] : null
  const logo = campaign?.logo || campaign?.properties?.logo

  return {
    logo,
    name: name ?? (app?.name || ''),
    link: app ? getAppLink(state, app.id) : '',
    id: campaign?.id,
  }
}

AppLogo.propTypes = {
  campaign: object,
  link: string,
  name: string,
  logo: object,
  id: string,
}

export default connect(mapStateToProps, null)(AppLogo)
